import { DataTable } from "../../../../shared/components/data-table/DataTable";
import { useTranslation } from "react-i18next";
import SectionIconCell from "../shared/SectionIconCell";
import SectionTitleCell from "../shared/SectionTitleCell";

const DataExplorersOverviewTable = ({ data }) => {
  const { t } = useTranslation();

  const columns = [
    {
      accessorKey: "icon",
      header: "",
      cell: ({ row }) => {
        const data = row.original;
        return <SectionIconCell icon={data.type.icon} />;
      },
    },
    {
      accessorKey: "title",
      header: t("dataExplorers.overview.table.header.title"),
      cell: ({ row }) => <SectionTitleCell data={row.original} />,
    },
    {
      accessorKey: "description",
      header: () => (
        <div className="hidden sm:table-cell">
          {t("dataExplorers.overview.table.header.description")}
        </div>
      ),
      cell: ({ row }) => {
        const data = row.original;
        return t(data.description);
      },
    },
  ];

  return <DataTable columns={columns} data={data} />;
};

export default DataExplorersOverviewTable;
